import { Plan, Subscription } from '@sxm-de/dev-kits/microservices-sdk/types';
import {
    SxmTypePhase,
    SxmTypePlan,
    SxmTypePlanPhase,
    SxmTypePlanType,
} from '@sxm-de/dev-kits/web-sdk/types';
import { getInfoByCapabilities } from '../get-info-by-capabilities';

export function mapSmsPlanToPlan(subscription: Subscription): SxmTypePlan[] {
    const uniquePackageNames = [
        ...new Set(subscription.plans.map((p) => p.packageName)),
    ];

    const allPlans = [
        ...(subscription.plans || []),
        ...(subscription.followonPlans || []),
    ];
    const plans = uniquePackageNames
        .map((uniquePackageName) => {
            return allPlans
                .filter((plan) => plan.packageName === uniquePackageName)
                .reduce((plans, plan) => {
                    const id = `${subscription.id}-${plan.packageName}`;

                    if (plans.some((p) => p.id === id)) {
                        return plans;
                    }

                    // let phase = SxmTypePhase.fullPrice;
                    // if (plan.price === 0) {
                    //     phase = SxmTypePhase.trial;
                    // } else if (subscription.followonPlans.length > 0) {
                    //     phase = SxmTypePhase.promo;
                    // }

                    const newPlan = {
                        id,
                        subscriptionId: subscription.id,
                        type: getPlanType(plan),
                        offerId: normalizePackageId(plan.packageName),
                        phases: [],
                        // checking with business to see if this is needed
                        streamingAvaliable: plan.hasStreamingService === true,
                        includesRadio: plan.hasRadioService === true,
                    } as SxmTypePlan;

                    return [...plans, newPlan];
                }, [] as SxmTypePlan[]);
        })
        .flat()
        .map((mappedPlan) => {
            const plan = subscription.plans.find(
                (plan) =>
                    mappedPlan.id === `${subscription.id}-${plan.packageName}`,
            );
            const follupPlans = (subscription.followonPlans || []).filter(
                (plan) =>
                    mappedPlan.id === `${subscription.id}-${plan.packageName}`,
            );

            let firstPhase: SxmTypePhase = 'fullPrice';
            if (plan!.price === 0) {
                firstPhase = 'trial';
            } else if (follupPlans.length > 0) {
                firstPhase = 'promo';
            }

            const phases = [
                { ...mapPhase(plan!), phase: firstPhase },
                ...follupPlans.map((plan, index) => {
                    /**
                     * TODO:
                     * Verify logic with existing phx app
                     */
                    const phase: SxmTypePhase =
                        index === follupPlans.length - 1
                            ? 'fullPrice'
                            : 'promo';
                    return { ...mapPhase(plan), phase };
                }),
            ];
            mappedPlan!.phases = phases;
            return mappedPlan;
        });

    return plans;
}

function mapPhase(plan: Plan): SxmTypePlanPhase {
    // let phase = SxmTypePhase.fullPrice;
    // if (plan.price === 0) {
    //     phase = SxmTypePhase.trial;
    // } else if (followPlanCount > 0) {
    //     phase = SxmTypePhase.promo;
    // }
    return {
        // phase: phase,
        term: {
            length: plan.termLength,
            startDate: parseDate(plan.startDate),
            endDate:
                parseDateOptional(plan.endDate) ??
                parseDateOptional(plan.nextCycleOn),
            price: calculatePricePerTerm(plan.price, plan.termLength),
        },
    } as SxmTypePlanPhase;
}

/**
 * TODO:
 * Refactor the functions below to common areas
 */
function parseDate(dateString: string): Date {
    return new Date(dateString);
}

function parseDateOptional(dateString: string | null | undefined): Date | null {
    if (!dateString) {
        return null;
    }
    return parseDate(dateString);
}

function calculatePricePerTerm(price: number, termLength: number): number {
    return price / termLength;
}

function normalizePackageId(packageId: string): string {
    if (packageId.startsWith('3_')) {
        return packageId.replace(/^3_/, 'SXM_');
    }
    return packageId;
}

function getPlanType(plan: Plan): SxmTypePlanType {
    /**
     * TODO:
     * use device type that is on the plan, instead of getting it from this call
     */
    const { type } = getInfoByCapabilities(plan.capabilities);
    const isMarine = type === 'marine';
    const isAviation = type === 'aviation';

    if (plan.dataCapable === true && !isMarine && !isAviation) {
        return 'infotainment';
    }

    if (isMarine) {
        return 'marine';
    }

    if (isAviation) {
        return 'aviation';
    }

    return 'entertainment';
}
